import { CurrencyCode } from './CurrencyCode';

export class CurrencyCodeAdapter {
    private static readonly countryCodeToCurrencyCodeMap: Readonly<Record<string, CurrencyCode>> = {
        US: CurrencyCode.usd,
        CA: CurrencyCode.cad,
        GB: CurrencyCode.gbp,
        EU: CurrencyCode.eur,
        JP: CurrencyCode.jpy,
        BR: CurrencyCode.brl,
        IN: CurrencyCode.inr,
        AU: CurrencyCode.aud,
        CX: CurrencyCode.aud,
        NR: CurrencyCode.aud,
        KI: CurrencyCode.aud,
        TUV: CurrencyCode.aud,
    };

    public static fromCountryCode(countryCode: string): CurrencyCode {
        if (countryCode in this.countryCodeToCurrencyCodeMap) {
            return this.countryCodeToCurrencyCodeMap[countryCode];
        }

        // Default to USD if not found
        return CurrencyCode.usd;
    }
}
